<template>
    <div class="total-prices">
        <h3>{{title}}</h3>
        <div class="total-start">
            <span class="total-text">Стоимость</span>
            <span>{{ currency }} {{ price.old }}</span>
        </div>
        <div class="total-sale">
            <span class="total-text">Скидка</span>
            <span>{{ currency }} {{ price.discount }}</span>
        </div>

        <div class="total-cart">
            <span class="total-text">К оплате</span>
            <span>{{ currency }} {{ price.total }}</span>
        </div>

        <div v-if="policy"
            class="checkout-politic checkbox-politic">
            <label
                class="checkout-politic-label"
                :class="{ error: showPoliticError }"
                ref="politicWrapper"
            >
                <input type="checkbox" v-model="politicChecked" />
                <span>
                Я даю согласие на обработку персональных данных согласно
                <a target="_blank" href="/info/politica">Политике конфиденциальности</a>
              </span>
            </label>
        </div>

        <a v-if="linkButton" class="btn full-width" :href="linkButton">{{buttonText}}</a>
        <button v-else class="btn full-width" :class="{ 'disabled-btn': !politicChecked }" @click="clickButton()">{{buttonText}}</button>
    </div>
</template>

<script>
    export default  {
        name: 'cart-total',
        title: 'Cart total component vuejs',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Сумма заказа'
            },
            currency: {
                type: String,
                required: false,
                default: '₽'
            },
            linkButton: {
                type: String,
                required: false
            },
            buttonText: {
                type: String,
                required: false,
                default: 'Купить'
            },
            policy: {
                type: Boolean,
                required: false,
                default: true
            },
            price: {
                type: (Array,Object),
                required: true
            }
        },
        data() {
            return {
                politicChecked: false,
                showPoliticError: false
            }
        },
        methods: {
            clickButton() {
                if (!this.politicChecked) {
                    this.showPoliticError = true
                    // убираем класс через 1 секунду
                    setTimeout(() => {
                        this.showPoliticError = false
                    }, 15000)
                    return
                }
                this.$emit('clickButton')
            }
        }
    }
</script>
